import type { ProjectVideo } from '@/data/projects';

export type ProjectVideoGroup = {
    key: string;
    labelNumber?: string;
    items: ProjectVideo[];
};

export const groupProjectVideos = (videos: ProjectVideo[]): ProjectVideoGroup[] => {
    const groups: ProjectVideoGroup[] = [];
    let ungroupedIndex = 0;

    videos.forEach((video) => {
        if (video.group) {
            const existing = groups.find((group) => group.key === `group-${video.group}`);
            if (existing) {
                existing.items.push(video);
                return;
            }

            groups.push({
                key: `group-${video.group}`,
                labelNumber: video.group,
                items: [video],
            });
            return;
        }

        ungroupedIndex += 1;
        groups.push({
            key: `item-${ungroupedIndex}-${video.popupName}`,
            labelNumber: undefined,
            items: [video],
        });
    });

    const hasAnyGroup = videos.some((video) => video.group);
    if (!hasAnyGroup && groups.length > 1) {
        return groups.map((group, index) => ({
            ...group,
            labelNumber: String(index + 1),
        }));
    }

    if (hasAnyGroup) {
        return groups;
    }

    return groups.map((group) => ({
        ...group,
        labelNumber: undefined,
    }));
};
